import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import authSelectors from '../../store/auth/authSelectors'
import { userRoles } from '../../store/auth/userTypes'
import { IShowForUserTypes } from './types'

const ShowForUserRoles: React.FC<IShowForUserTypes> = ({ roles, children, message }) => {
  const userRoles = useSelector(authSelectors.userRoles)
  const returnMessage = message ? (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Typography variant='boldTextXlarge'>{message}</Typography>
    </Box>
  ) : (
    <></>
  )

  if (!userRoles) return returnMessage

  const found = userRoles.some(role => roles.includes(role as userRoles))

  if (found) return <>{children}</>

  return returnMessage
}

export default ShowForUserRoles
